import { render, staticRenderFns } from "./card-select-products-bulk.vue?vue&type=template&id=3e7a7f8b&"
import script from "./card-select-products-bulk.vue?vue&type=script&lang=js&"
export * from "./card-select-products-bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports